import { AlertTriangle } from 'lucide-react';
import { useState } from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

type Props = {
  text: string;
  title?: string;
  showLongText?: boolean;
  onlyIcon?: boolean;
};

export const EventWarning = ({
  text,
  showLongText = false,
  title = 'No matching orders',
  onlyIcon = false,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0} open={isOpen} onOpenChange={setIsOpen}>
        <TooltipTrigger onClick={() => setIsOpen(!isOpen)} asChild>
          <div
            className={cn(
              'flex cursor-pointer flex-row items-center gap-1 rounded-[6px] bg-[#F1A32E1A] px-1.5 py-2 text-sm text-[#F1A32E]',
              onlyIcon && 'h-9 w-9 justify-center',
            )}
          >
            {onlyIcon ? (
              <AlertTriangle size={16} />
            ) : (
              <>
                <AlertTriangle size={16} />
                {showLongText ? (
                  <span className="ml-1">{title}</span>
                ) : (
                  <>
                    <span className="ml-1 max-sm:hidden">Warning</span>
                    <span className="ml-1 sm:hidden">{title}</span>
                  </>
                )}
              </>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent
          className="max-w-[300px]"
          onPointerDownOutside={() => setIsOpen(false)}
        >
          <div className="text-sm">{text}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
